export const SpaceDistributorHandleDimensions = {
  width: 6,
  offsetTop: 10,
  borderRadius: 4,
  padding: 2,
};

/**
 * Custom event name for the SpaceDistributorHandle component MouseDown event on the PropPane
 */
export const PropPaneDistributionHandleCustomEvent = "propPaneMouseDown";

/**
 * Number of columns in a section
 */
export const SectionColumns = 12;

/**
 * Minimum width of a zone in columns
 */
export const ZoneMinColumnWidth = 2;

/**
 * Number of pixels a zone can shrink when it has reached minimum column limit (ZoneMinColumnWidth)
 */
export const ZoneMinShrinkablePixels = 10;
